import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../images/logo1.svg';
import {  toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { getCustomer } from '../../redux/actions/customer/CustomerAction';

function CustomerLogin({ customer,history, getCustomer}){
    const location = useLocation();
    

    const [email,setEmail]=useState('');
    const[password,setPassword]=useState('');

    useEffect(()=>{
        console.log(customer);
    },[customer]);
    

    // useEffect(() => {
    //     console.log('location state', location.state);
    //     if (redirectPath !== `/customer/${user.id}/cart`) {
    //         toast.error('Login to visit admin pages!');
    //     }
    // }, []);

    const handleLogin = (e) => {
        e.preventDefault();
        const user=JSON.parse(localStorage.getItem('customerlist'));
        
        let redirectPath;
        const getUser=user.filter((e)=>e.email===email)[0];
        if(getUser){
            if(getUser.password===password){
                getCustomer(getUser.id);
                redirectPath = location.state?.from || `/customer/${getUser.id}/cart`;
            }else{
                toast.error('Credential Mismatch!!');
                return false;
            }
        }else{
            toast.error('Customer Not Found!!');
            return false;
        }
        console.log(getUser);
        console.log(redirectPath);
        history.push({

            pathname: redirectPath
        });
    };

    

    return(
        <div>
            <section className="container-fluid maindiv mt-5">
                <div className="container formdiv my-5 d-flex shadow">
                    <img src={logo} className="formimg"/>
                    <form className="myform mt-4" onSubmit={handleLogin}>
                        <div className="form-group mt-2">
                            <label htmlFor="exampleUserEmail">Email</label>
                            <input value={email} onChange={(e) => setEmail( e.target.value )} type="email" className="form-control" id="exampleUserEmail" required />
                        </div>
                        <div className="form-group mt-2">
                            <label htmlFor="examplePassword">Password</label>
                            <input value={password} onChange={(e) => setPassword(e.target.value )} type="password" className="form-control" id="examplePassword" required />
                        </div>
                        <br></br>
                        <button type="submit" className="btn btn-primary">Submit</button>
                        <p className="mt-3">First time here?<span><Link to="/customer/add"> Create Customer </Link></span></p>
                    </form>
                </div>
            </section>
            <ToastContainer />
        </div>
    );
}

const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        customer:state.customers,
    };

};

const mapDispatchToProps = {
    getCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerLogin);